////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import { modalsActionCreators } from '../../store/actions'
/////////ASSETS/////////
import QuestionMarque from '../../assets/icones/global/question-mark-blue.svg'
import QuestionMarqueAlt from '../../assets/icones/global/question-mark-white.svg'

/////////STYLED/////////
const TooltipHelpWrapper = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	grid-column-gap: 10px;
	justify-content: flex-start;
	align-items: center;
`
const QuestionMarqueImgWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	max-height: 16px;
	max-width: 16px;
	cursor: pointer;
`
const QuestionMarqueImg = styled.img`
	max-height: 16px;
	max-width: 16px;
`
/////////STYLED/////////
const POSITION = new Map([
	[1, 'start'],
	[2, 'end'],
])

/**
 *
 * @param {number} by default 1 childrenPos
 * @param {JSX.Element} children
 * @param {string} content
 * @param {boolean} insideModal
 * @param {boolean} altImg
 * @return {JSX.Element}
 * @constructor
 */
const TooltipHelp = ({ childrenPos = 1, children, icon, content, insideModal = false, altImg = false }) => {
	const { showModal } = useSelector(
		(state) => ({
			showModal: state.tooltipHelp.showModal,
		}),
		shallowEqual
	)

	const modalAction = bindActionCreators(modalsActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleOpenModal = () => {
		if (!showModal) {
			modalAction.tooltipHelpOpen(content, icon, insideModal)
		} else {
			modalAction.tooltipHelpClose()
		}
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TooltipHelpWrapper>
			{POSITION.get(childrenPos) === 'start' && children}
			<QuestionMarqueImgWrapper onClick={handleOpenModal}>
				<QuestionMarqueImg src={altImg ? QuestionMarqueAlt : QuestionMarque} />
			</QuestionMarqueImgWrapper>
			{POSITION.get(childrenPos) === 'end' && children}
		</TooltipHelpWrapper>
	)
}

TooltipHelp.propTypes = {}

TooltipHelp.defaultPropTypes = {}

export default TooltipHelp
